module.exports = __webpack_public_path__ + "static/media/fert2.35142a6b.png";